<template>
  <div class="side-scroll-bar">
    <el-collapse v-model="activeNames" class="widget-collapse">
      <el-collapse-item name="1" :title="i18nt('designer.containerTitle')" class="collapse-item">
        <draggable
          tag="ul"
          :list="containers"
          item-key="id"
          :group="{ name: 'dragGroup', pull: 'clone', put: false }"
          class="field-widget-container"
          :clone="handleContainerWidgetClone"
          ghost-class="ghost"
          :sort="false"
          :move="checkContainerMove"
          @end="onContainerDragEnd"
        >
          <template #item="{ element: ctn }">
            <li class="container-widget-item" :title="ctn.displayName" @dblclick="addContainerByDbClick(ctn)">
              <span>
                <svg-icon :icon-class="ctn.icon" class-name="color-svg-icon" />
                <div class="container-widget-item-label">{{ i18n2t(`designer.widgetLabel.${ctn.type}`, `extension.widgetLabel.${ctn.type}`) }}</div>
              </span>
            </li>
          </template>
        </draggable>
      </el-collapse-item>

      <el-collapse-item name="2" :title="i18nt('designer.basicFieldTitle')">
        <draggable
          tag="ul"
          :list="basicFields"
          item-key="id"
          :group="{ name: 'dragGroup', pull: 'clone', put: false }"
          class="field-widget-container"
          :move="checkFieldMove"
          :clone="handleFieldWidgetClone"
          ghost-class="ghost"
          :sort="false"
        >
          <template #item="{ element: fld }">
            <li class="field-widget-item" :title="fld.displayName" @dblclick="addFieldByDbClick(fld)">
              <span>
                <svg-icon :icon-class="fld.icon" class-name="color-svg-icon" />
                <div class="container-widget-item-label">{{ i18n2t(`designer.widgetLabel.${fld.type}`, `extension.widgetLabel.${fld.type}`) }}</div>
              </span>
            </li>
          </template>
        </draggable>
      </el-collapse-item>

      <el-collapse-item name="3" :title="i18nt('designer.advancedFieldTitle')">
        <draggable
          tag="ul"
          :list="advancedFields"
          item-key="id"
          :group="{ name: 'dragGroup', pull: 'clone', put: false }"
          :move="checkFieldMove"
          :clone="handleFieldWidgetClone"
          ghost-class="ghost"
          :sort="false"
        >
          <template #item="{ element: fld }">
            <li class="field-widget-item" :title="fld.displayName" @dblclick="addFieldByDbClick(fld)">
              <span>
                <svg-icon :icon-class="fld.icon" class-name="color-svg-icon" />
                <div class="container-widget-item-label">{{ i18n2t(`designer.widgetLabel.${fld.type}`, `extension.widgetLabel.${fld.type}`) }}</div>
              </span>
            </li>
          </template>
        </draggable>
      </el-collapse-item>

      <el-collapse-item name="4" :title="i18nt('designer.customFieldTitle')">
        <draggable
          tag="ul"
          :list="customFields"
          item-key="id"
          :group="{ name: 'dragGroup', pull: 'clone', put: false }"
          :move="checkFieldMove"
          :clone="handleFieldWidgetClone"
          ghost-class="ghost"
          :sort="false"
        >
          <template #item="{ element: fld }">
            <li class="field-widget-item" :title="fld.displayName" @dblclick="addFieldByDbClick(fld)">
              <span>
                <svg-icon :icon-class="fld.icon" class-name="color-svg-icon" />
                <div class="container-widget-item-label">{{ i18n2t(`designer.widgetLabel.${fld.type}`, `extension.widgetLabel.${fld.type}`) }}</div>
              </span>
            </li>
          </template>
        </draggable>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import SvgIcon from '@/components/svg-icon';
import { containers, basicFields, advancedFields, customFields } from '../widgetsConfig';
// import Draggable from 'vuedraggable';
import { useI18n } from '@/utils/i18n';
import { reactive, toRefs, inject, onMounted } from 'vue';
export default {
  components: {
    SvgIcon,
    // Draggable,
  },
  icon: 'grid',
  label: 'toolbox.widgets',
  name: 'widgets',
  setup(props) {
    const designer = inject('designer');
    const getBannedWidgets = inject('getBannedWidgets');
    const data = reactive({
      activeNames: ['1', '2', '3', '4'],
      advancedFields,
      basicFields,
      containers,
      customFields,
      label: 'toolbox.widgets',
    });

    const { i18nt, i18n2t } = useI18n();

    const isBanned = wName => {
      return getBannedWidgets().indexOf(wName) > -1;
    };
    const loadWidgets = () => {
      data.containers = containers
        .map(con => {
          return {
            ...con,
            displayName: i18n2t(`designer.widgetLabel.${con.type}`, `extension.widgetLabel.${con.type}`),
          };
        })
        .filter(con => {
          return !con.internal && !isBanned(con.type);
        });

      data.basicFields = basicFields
        .map(fld => {
          return {
            ...fld,
            displayName: i18n2t(`designer.widgetLabel.${fld.type}`, `extension.widgetLabel.${fld.type}`),
          };
        })
        .filter(fld => {
          return !isBanned(fld.type);
        });

      data.advancedFields = advancedFields
        .map(fld => {
          return {
            ...fld,
            displayName: i18n2t(`designer.widgetLabel.${fld.type}`, `extension.widgetLabel.${fld.type}`),
          };
        })
        .filter(fld => {
          return !isBanned(fld.type);
        });

      data.customFields = customFields
        .map(fld => {
          return {
            ...fld,
            displayName: i18n2t(`designer.widgetLabel.${fld.type}`, `extension.widgetLabel.${fld.type}`),
          };
        })
        .filter(fld => {
          return !isBanned(fld.type);
        });

      if (import.meta.env.VITE_APP_ENV_STANDARD) {
        let deleteFields = ['m-sub-form', 'm-slot'];
        data.containers = containers.filter(x => {
          return (
            deleteFields.findIndex(f => {
              return f == x.type;
            }) == -1
          );
        });
        data.basicFields = basicFields.filter(x => {
          return (
            deleteFields.findIndex(f => {
              return f == x.type;
            }) == -1
          );
        });
        data.advancedFields = advancedFields.filter(x => {
          return (
            deleteFields.findIndex(f => {
              return f == x.type;
            }) == -1
          );
        });
      }
    };

    const handleContainerWidgetClone = origin => {
      return designer.copyNewContainerWidget(origin);
    };

    const handleFieldWidgetClone = origin => {
      return designer.copyNewFieldWidget(origin);
    };

    const checkContainerMove = evt => {
      return designer.checkWidgetMove(evt);
    };

    const checkFieldMove = evt => {
      return designer.checkFieldMove(evt);
    };

    const onContainerDragEnd = () => {};

    const addContainerByDbClick = container => {
      designer.addContainerByDbClick(container);
    };

    const addFieldByDbClick = widget => {
      designer.addFieldByDbClick(widget);
    };

    onMounted(() => {
      loadWidgets();
    });

    return {
      ...toRefs(data),
      addContainerByDbClick,
      addFieldByDbClick,
      checkContainerMove,
      checkFieldMove,
      handleContainerWidgetClone,
      handleFieldWidgetClone,
      i18n2t,
      i18nt,
      onContainerDragEnd,
    };
  },
  sort: 0,
};
</script>
<style lang="scss" scoped>
.color-svg-icon {
  -webkit-font-smoothing: antialiased;
  color: #8d8d8d;
  font-size: 22px;
}
.el-collapse-item {
  :v-deep(ul > li) {
    list-style: none;
  }
  &.is-active {
    border-bottom: none 0px #fafafa;
  }
}

.widget-collapse {
  border-top-width: 0;
  height: 100%;

  :deep(.el-collapse-item__header) {
    padding-left: 8px;
    font-weight: bold;
    height: 38px;
    line-height: 45px;
    background-color: #fcfcfc;
  }

  :deep(.el-collapse-item__content) {
    padding-bottom: 0px;

    ul {
      padding-left: 0px; /* 重置IE11默认样式 */
      padding-inline-start: 0px;
      margin: 0; /* 重置IE11默认样式 */
      margin-block-start: 0;
      margin-block-end: 0;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      width: 260px;
      border: 1px solid #dcdfe6;
      border-left: 0px;
      border-right: 0px;
      border-bottom: 0px;
      box-sizing: border-box;

      &:after {
        content: '';
        display: block;
        clear: both;
      }

      .container-widget-item,
      .field-widget-item {
        display: block;
        width: 86px;
        height: 95px;
        line-height: 95px;
        cursor: move;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        background: #fff;
        border: 1px solid #dcdfe6;
        border-left: 0px;
        border-top: 0px;
      }

      .container-widget-item:hover,
      .field-widget-item:hover {
        background: #f1f2f3;
        // border-color: var(--vf-color-primary, #409eff);

        .color-svg-icon {
          color: $--color-primary;
        }
      }

      .drag-handler {
        position: absolute;
        top: 0;
        left: 160px;
        background-color: #dddddd;
        border-radius: 5px;
        padding-right: 5px;
        font-size: 11px;
        color: #666666;
      }

      li span {
        display: inline-flex;
        width: 100%;
        height: 100%;
        line-height: 80px;
        flex-direction: column;
        text-align: center;
        align-items: center;
        justify-content: center;

        .container-widget-item-label {
          height: 25px;
          line-height: 25px;
          margin-top: 2px;
        }
      }
    }
  }
}
</style>
